module.exports = __webpack_public_path__ + "static/media/simplonbp-light-webfont.62406d53.svg";